import { FabricObject, Textbox } from 'fabric';
import type { AutoFitConfig } from '../text';
import type { TextAlign } from '../shared/types/text-align';

/** @deprecated Use TextAlign — kept as an alias for the public API. */
export type AutoFitTextAlign = TextAlign;

export interface AutoFitTextCreateConfig {
  left: number;
  top: number;
  text?: string;
  width?: number;
  fill?: string;
  fontFamily?: string;
  fontWeight?: number | string;
  fontStyle?: 'normal' | 'italic';
  textAlign?: AutoFitTextAlign;
  splitByGrapheme?: boolean;
  autoFit?: AutoFitConfig;
}

export type AutoFitTextbox = Textbox & { autoFit: AutoFitConfig };

export function isAutoFitTextbox(obj: FabricObject | null | undefined): obj is AutoFitTextbox {
  return !!obj && obj instanceof Textbox && !!obj.autoFit;
}
